import { render, staticRenderFns } from "./Baskets.vue?vue&type=template&id=604e1dd9&"
import script from "./Baskets.js?vue&type=script&lang=js&"
export * from "./Baskets.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports